import LocalStorage from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';
import _find from 'lodash/find';
import _findIndex from 'lodash/findIndex';
import _isEmpty from 'lodash/isEmpty';
import _forEach from 'lodash/forEach';
import _get from 'lodash/get';
import _orderBy from 'lodash/orderBy';
import _groupBy from 'lodash/groupBy';

// this is for extract content for analytics heading by removing rich text from heading
export const extractTextFromHtml = (value) => {
    if (!__SERVER__ && value) {
        const span = document.createElement('span');
        span.innerHTML = value;
        return (
            (span.textContent && span.textContent.trim()) ||
            (span.innerText && span.innerText.trim())
        );
    }
    return value;
};

/** *
 * @param {Array} [required] items with heading in each item
 * @return {string} string format required for analytics
 * Usage:
 * getProgramName([{ heading: 'Skinny Jeans' }]) will return '1-SJ'
 */
const getProgramName = (items = []) => {
    const programName = [];
    items.forEach(({ heading }, index) => {
        heading = heading && extractTextFromHtml(heading); // this is for extract content for analytics heading by removing rich text from heading
        const name =
            heading &&
            heading.split(' ').reduce((acc, curr) => [...acc, curr.charAt(0).toUpperCase()], []);
        if (name) {
            programName.push(`${index + 1}-${name.join('')}`);
        }
    });
    return programName.join('|');
};

export const getInteractiveVizNavFromSession = (programId) => {
    const storedInteractiveVizNav = LocalStorage.getData('interactiveVizNav') || [];
    return _find(storedInteractiveVizNav, (programs) => programs.programId === programId) || {};
};

export const isNotIrisInTool = () => !__SERVER__ && !window.yodairis;

export const setInteractiveVizNavInSession = (programId, attr, value, cacheMins) => {
    let storedInteractiveVizNav = LocalStorage.getData('interactiveVizNav') || [];
    const currentProgram = getInteractiveVizNavFromSession(programId);
    if (!_isEmpty(currentProgram)) {
        storedInteractiveVizNav = storedInteractiveVizNav.map((program) => {
            const current = program;
            if (program.programId === programId) {
                current[attr] = value;
            }
            return current;
        });
    } else {
        const current = {
            [attr]: value,
            programId,
        };
        storedInteractiveVizNav = [...storedInteractiveVizNav, current];
    }
    LocalStorage.setData('interactiveVizNav', storedInteractiveVizNav, '', '', true, cacheMins);
};

export const parseQueryString = (url) => {
    const query = {};
    url.replace(/^.*\?/, '').replace(/([^=]+)=([^&]*)&?/g, (match, key, value) => {
        query[key] = decodeURIComponent(value.replace('+', ' '));
        return '';
    });
    return query;
};

export const getSelectedProgramFromFilters = (
    programId,
    navLinks = [],
    excludeQueryString = [],
    cacheMins
) => {
    let selectedProgram;
    if (navLinks.length > 0) {
        const pageUrl = window.location.href;
        const selectedFacetList = [];
        if (pageUrl) {
            const queryParams = parseQueryString(pageUrl);
            _forEach(queryParams, (val, key) => {
                const filter = { [key.split('_').join(' ')]: val };
                if (excludeQueryString.indexOf(key) === -1) {
                    selectedFacetList.push(filter);
                }
            });
        }

        const filteredList = [];
        navLinks.forEach((navLink = {}) => {
            const url = _get(navLink, 'link.url', '');
            const filters = [];
            if (url) {
                const queryParams = parseQueryString(url);
                _forEach(queryParams, (val, key) => {
                    const filter = { [key.split('_').join(' ')]: val };
                    if (excludeQueryString.indexOf(key) === -1) {
                        filters.push(filter);
                    }
                });
            }

            let i = 0;
            // if some thing is failing please verify excludeQueryString in gallery - common - fitfinder - preferences
            filters.length <= selectedFacetList.length &&
                filters.forEach((filter) => {
                    // If anyone of filter match is missing need to ignore that filter
                    if (_findIndex(selectedFacetList, filter) !== -1) {
                        // eslint-disable-next-line no-plusplus
                        ++i;
                    }
                });

            filteredList.push({ key: navLink.heading, match: i >= filters.length ? i : 0 });
        });
        const orderedFilterList = _orderBy(filteredList, (x) => x.match, 'desc');
        const groupedFilterList = _groupBy(filteredList, (x) => x.match);
        if (
            orderedFilterList &&
            orderedFilterList.length > 0 &&
            groupedFilterList[orderedFilterList[0].match].length === 1
        ) {
            selectedProgram = orderedFilterList[0].key;
        }
    } else {
        setInteractiveVizNavInSession(programId, 'heading', '', cacheMins);
    }
    return selectedProgram;
};

export const validQueryString = (url, excludeQueryString = []) => {
    const queryParams = parseQueryString(url);
    const filters = [];
    _forEach(queryParams, (val, key) => {
        // const modifiedKey = key === 'item_type' ? 'jean_type' : key;
        const filter = { [key.split('_').join(' ')]: val };
        if (excludeQueryString.indexOf(key) === -1) {
            filters.push(filter);
        }
    });
    return filters.length > 0;
};

export const getExcludeFiltersList = (preferences = {}) => {
    const excludeQueryString = [
        'productGridView',
        'cm_re',
        'id',
        'product_size',
        'activeFacetId',
        'dpAkamaiOverride',
        'redirectTerm',
        'contentdate',
        'channel',
    ];
    return _get(preferences, 'interactiveVizNav.excludeQueryString', excludeQueryString);
};
export default getProgramName;
